import * as mhReact from "mhreact";
import Mainpage from "../pages/main/index.jsx";
export default function App() {
  return mhReact.createElement("div", null, mhReact.createElement(Mainpage, null));
}